<!-- App.vue -->
<template>
  <div v-if="!authReady" class="app-loading">
    <div class="loading-content">
      <div class="logo">MyHarf</div>
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>
  </div>
  <div v-else id="app">
    <Navbar />
    <router-view />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";
import Navbar from "@/components/Navbar.vue";

const authStore = useAuthStore();
const authReady = ref(false);

onMounted(async () => {
  try {
    // Wait for auth but with a reasonable timeout
    const timeoutPromise = new Promise((resolve) => {
      setTimeout(() => {
        console.warn("⏰ Auth timeout - showing app anyway");
        resolve(false);
      }, 3000);
    });

    const authPromise = authStore.initialize().then(() => true);
    const result = await Promise.race([authPromise, timeoutPromise]);

    // If auth initialized successfully, use that result
    if (result === true) {
      console.log("✅ Auth initialized successfully");
    }
  } catch (error) {
    console.warn("⚠️ Auth had issues, showing app anyway:", error);
  } finally {
    authReady.value = true;
  }
});
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  background: #f8f9fa;
}

.app-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #001829;
}

.loading-content {
  text-align: center;
  color: #fff;
}

.loading-content .logo {
  font-size: 48px;
  font-weight: 800;
  background: linear-gradient(135deg, #ff8000, #ffa500);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 24px;
}

.loading-content .spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 128, 0, 0.2);
  border-top: 4px solid #ff8000;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 16px;
}

.loading-content p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
